export default {
	fadeIn: 'fadeIn 0.5s',
	fadeOut: 'fadeOut 0.5s',
	slideInRight: 'slideInRight 0.3s',
	slideOutRight: 'slideOutRight 0.3s'
}


// WEBPACK FOOTER //
// ./src/App/Globals/animations.js